import React, { Component } from 'react';
import { Container, Row, Col, Button, Label } from 'reactstrap';
import { withStyles, Card } from '@material-ui/core';
import * as Constants from '../Pages/Constants';

class UpdatingParametersPopup extends Component{

    render(){
        const { classes, message } = this.props;
    	return(
            <div className={classes.popup_background}>
                <Col style={{ height: "100%", width: "100%", display: "grid", placeItems: "center", overflow: "auto" }}>
                    <Container style={{ height: "100%", width: "100%"}} fluid>
                        <Row style={{ height: "100%", width: "100%" }}>
                            <Col style={{ height: "100%", width: "100%", display: "grid", placeItems: "center", overflow: "auto" }}>
                                <Card className={classes.popup} style={{ height: "150px", width: "300px", overflowY: "auto" }}>
                                   	<br/>
                                   	<Row>
                                        <Col style={{ height: "100%", width: "100%", display: "grid", placeItems: "center", overflow: "auto" }}>
                                        <Label style={{fontWeight: "bold", textAlign: "center" }}>{message}</Label>
                                        <br/>
                                        {this.props.showCloseButton ?
                                            <Button onClick={this.props.cancelPopup} outline color="success" style={{maxWidth:"50px"}}>OK</Button>
                                            :
                                            null
                                        }
                                        </Col>
                                   	</Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </div>
    	);
    }
}
export default withStyles(Constants.styles)(UpdatingParametersPopup);